import { Component } from '@angular/core';

@Component({
  selector: 'app-iackathon-deliverable-list-page',
  imports: [],
  templateUrl: './iackathon-deliverable-list-page.component.html',
  styleUrl: './iackathon-deliverable-list-page.component.scss',
})
export class IackathonDeliverableListPageComponent {

}
